import { DNI_CHECK, EMAIL_CHECK, ONLY_NUMBERS_CHECK } from './regexes'

/**
 * Check if the given string value is a valid email.
 */
export const checkErrorEmail = value => EMAIL_CHECK.test(value)

/**
 * Check if the given Input value is a valid email.
 */
export const checkInputErrorEmail = customMessage => value =>
  checkErrorEmail(value) ? '' : customMessage || 'Formato de email incorrecto.'

/**
 * Check if the given file satisfy the maximum size allowed.
 */
export const checkErrorFileMaxSize = (value, maxSize) => {
  const isFile = value instanceof File

  if (!isFile) {
    return true
  }

  const maxBytes = maxSize * 1024 * 1024

  return value?.size <= maxBytes
}

/**
 * Check if the Input file satisfy the maximum size allowed.
 */
export const checkInputErrorFileMaxSize = (maxSize, customMessage) => value =>
  checkErrorFileMaxSize(value, maxSize) ? '' : customMessage || `Este campo permite archivos de hasta ${maxSize}mb.`

/**
 * Check if the given value satisfy the maximum length allowed.
 */
export const checkErrorMaxLength = (value, maxLength) => {
  const isString = typeof value === 'string'

  return isString ? value?.length <= maxLength : value.toString().length <= maxLength
}

/**
 * Check if the given Input value satisfy the maximum length allowed.
 */
export const checkInputErrorMaxLength = (maxLength, customMessage) => value => {
  const isString = typeof value === 'string'

  if (checkErrorMaxLength(value, maxLength)) {
    return ''
  }

  return customMessage || isString
    ? `Este campo excede el máximo de ${maxLength} caracteres permitido.`
    : `Este campo permite hasta ${maxLength} dígitos.`
}

/**
 * Check if the given value satisfy the minimum length allowed.
 */
export const checkErrorMinLength = (value, minLength) => {
  const isString = typeof value === 'string'

  return isString ? value?.length >= minLength : value.toString().length >= minLength
}

/**
 * Check if the given Input value satisfy the minimum length allowed.
 */
export const checkInputErrorMinLength = (minLength, customMessage) => value => {
  const isString = typeof value === 'string'

  if (checkErrorMinLength(value, minLength)) {
    return ''
  }

  return customMessage || isString
    ? `Este campo debe tener un mínimo de ${minLength} caracteres.`
    : `Este campo debe tener un mínimo de ${minLength} dígitos.`
}

/**
 * Check if the given string value contain only numbers.
 */
export const checkErrorOnlyNumbers = value => ONLY_NUMBERS_CHECK.test(value)

/**
 * Check if the given Input value contain only numbers.
 */
export const checkInputErrorOnlyNumbers = customMessage => value =>
  checkErrorOnlyNumbers(value) ? '' : customMessage || 'Este campo sólo permite números.'

/**
 * Check if the given string value is empty.
 */
export const checkErrorRequired = value => {
  const parsedValue = value ?? ''
  const isString = typeof parsedValue === 'string'

  return isString ? parsedValue?.trim().length > 0 : parsedValue.toString().trim().length > 0
}

/**
 * Check if the given Input value is empty.
 */
export const checkInputErrorRequired = customMessage => value =>
  checkErrorRequired(value) ? '' : customMessage || 'Este campo es obligatorio.'

/**
 * Check if the value meet the requirements by the given regular expression.
 */
export const checkErrorRegEx = (value, regex) => value.match(regex)

/**
 * Check if the Input value meet the requirements by the given regular expression.
 */
export const checkInputErrorRegEx = (regex, customMessage) => value =>
  checkErrorRegEx(value, regex) ? '' : customMessage || 'El campo no cumple con los requerimientos mínimos'

/**
 * Check if the given string value has a DNI valid format.
 */
export const checkErrorDniFormat = value => DNI_CHECK.test(value)

/**
 * Check if the given string value has a DNI valid format.
 */
export const checkInputErrorDniFormat = customMessage => value =>
  checkErrorDniFormat(value) ? '' : customMessage || 'Formato de Rut no válido.'
